/**
 * Created by Victor Rojo on 9/5/19.
 */
import { Component }     from '@angular/core';

@Component({
  templateUrl: './Start.component.html',
  styleUrls: ['./Start.component.css']
})
export class StartComponent {

}
